import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemoveMilestoneFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveMilestoneFormProps) => {
  const [
    fnRemoveMilestoneForm,
    { loading }
  ] = ds.useRemoveMilestone();

  const handleSubmit = async (id: string) => {

    await fnRemoveMilestoneForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
